import React, { useEffect, useRef } from 'react';
import { Loader2, X } from 'lucide-react';
import './assetExport.css';

export const AssignmentRemovalDialog = ({ person, roleLabel, selfRemoval, busy, error, onCancel, onConfirm }) => {
  const ref = useRef(null);
  useEffect(() => {
    const dialog = ref.current;
    dialog.showModal();
    return () => dialog.close();
  }, []);
  return (
    <dialog ref={ref} className="asset-export-dialog" style={{ width: '30rem' }} role="alertdialog" aria-labelledby="assignment-remove-title"
      aria-describedby="assignment-remove-description" data-testid="assignment-remove-dialog"
      onCancel={event => { event.preventDefault(); if (!busy) onCancel(); }}>
      <div className="flex items-start justify-between gap-3">
        <h2 id="assignment-remove-title" className="text-lg font-semibold" data-testid="assignment-remove-title">Quitar asignación</h2>
        <button type="button" onClick={onCancel} disabled={busy} aria-label="Cerrar confirmación" title="Cerrar"
          className="p-1 rounded hover:bg-black/5" data-testid="assignment-remove-close"><X className="w-5 h-5" /></button>
      </div>
      <p id="assignment-remove-description" className="my-4 text-sm [overflow-wrap:anywhere]" data-testid="assignment-remove-description">
        ¿Quitar a <strong>{person.name}</strong> de <strong>{roleLabel}</strong> en este activo? Los demás usuarios y funciones se conservarán.
      </p>
      {selfRemoval && <p className="text-sm text-amber-700 mb-3" data-testid="assignment-remove-self-warning">Si es tu último vínculo, dejarás de tener acceso a este activo.</p>}
      {error && <p className="text-sm text-red-700 mb-3" role="alert" data-testid="assignment-remove-error">{error}</p>}
      <div className="flex flex-wrap justify-end gap-2">
        <button type="button" onClick={onCancel} disabled={busy} className="btn-secondary text-sm" data-testid="assignment-remove-cancel">Cancelar</button>
        <button type="button" onClick={onConfirm} disabled={busy} className="text-sm px-3 py-2 rounded-md bg-red-600 hover:bg-red-700 text-white flex gap-2 items-center disabled:opacity-50 transition-colors" data-testid="assignment-remove-confirm">
          {busy && <Loader2 className="w-4 h-4 animate-spin" />}{busy ? 'Guardando…' : 'Quitar persona'}
        </button>
      </div>
    </dialog>
  );
};